import React, { Component } from 'react'

import { connect } from 'react-redux'

import {
  BrowserRouter as Router,
  Route,
  Link, Switch,
} from 'react-router-dom'

import { PrivateRoute } from '../../PrivateRoute'


import Login from '../Login/LoginComponent'

import Home from './Home'
import Header from './Header'

import GetUser from './User/ListesComptes'
import AddUser from './User/AddUser'
import UpdateUser from './User/EditCompte'
import ExportUser from './User/ExportEmail'


import ImportArticle from './Article/AddArticle'
import EditProduit from './Article/EditProduit'
import ListArticle from './Article/GetGroupArticle'

const mapStateToProps = state => (
  {
    app: state.app,
  }
)

class ConnectedApp extends Component {

  render() {

    return (
      <div>
        <Router>
          <div>
            <Header />

            <Switch>
              <Route exact path="/" component={Login} />
              <Route exact path="/login" component={Login} />

              <PrivateRoute exact path="/home" component={Home} />

              <PrivateRoute exact path="/comptes" component={GetUser} />
              <PrivateRoute exact path="/comptes/addUser" component={AddUser} />
              <PrivateRoute exact path="/comptes/update/:idUser" component={UpdateUser} />

              <PrivateRoute exact path="/email" component={ExportUser} />

              <PrivateRoute exact path="/produits" component={ListArticle} />
              <PrivateRoute exact path="/produits/addArticle" component={ImportArticle} />
              <PrivateRoute exact path="/produits/update/:idProduct" component={EditProduit} />
            </Switch>
          </div>
        </Router>
      </div>
    )
  }
}

const App = connect(mapStateToProps)(ConnectedApp)
export default App



// WEBPACK FOOTER //
// ./src/components/Protected/ProtectedRoute.js